import { Link } from "react-router-dom";
import type { Collection } from "@/types";
import SectionHeading from "@/components/base/SectionHeading";

interface FeaturedCollectionsProps {
  items: Collection[];
}

export default function FeaturedCollections({ items }: FeaturedCollectionsProps) {
  return (
    <section className="bg-background-100 py-12">
      <div className="mx-auto w-full px-4 md:px-6">
        <SectionHeading
          title="热门推荐专题"
          subtitle="精选合集，一次看个够"
          moreTo="/category"
          moreLabel="全部作品"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <Link
              key={c.id}
              to={`/category?collection=${c.id}`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300"
            >
              <div className="relative w-full overflow-hidden" style={{ aspectRatio: "4 / 3" }}>
                <img
                  src={c.cover}
                  alt={`${c.title}专题封面`}
                  title={`${c.title} - 糖心传媒影视专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-accent-700 backdrop-blur">
                  {c.workIds.length} 部作品
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {c.title}
                </h3>
                <p className="mt-1 text-xs font-medium text-accent-600">{c.subtitle}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <span className="mt-3 flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入专题
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}